module.exports = __webpack_public_path__ + "static/media/tooltip.a178b3f5.svg";